import React from 'react';
export function Footer() {
  return <footer className="w-full bg-sage text-white" data-id="element-107" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 text-center" data-id="element-108" data-mp="3gfsnkey6wyo1">
        <p className="font-serif font-bold text-lg sm:text-xl" data-id="element-109" data-mp="3gh3swj7aaeh9">
          The Life Coach&apos;s Complete System™
        </p>
        <p className="mt-3 text-white/80 text-sm sm:text-base" data-id="element-110" data-mp="36oxyl2tk7kyw">
          The #1 done-for-you session system for life coaches.
        </p>
        <p className="mt-1 text-white/60 text-sm italic" data-id="element-111" data-mp="3ufjww2drhqvp">
          Because coaching shouldn&apos;t start with dread the night before.
        </p>
        <p className="mt-8 text-xs text-white/50" data-id="element-112" data-mp="3lem1g8he2roq">
          © {new Date().getFullYear()} The Life Coach&apos;s Complete System. All
          rights reserved.
        </p>
      </div>
    </footer>;
}